/* src/app/common/components/signature/signature.component.scss */
:host {
  display: inline-block;
  font-size: 1rem;
}
.logo-container {
  font-size: inherit;
  display: flex;
  align-items: center;
}
.logo-container > * {
  padding: 0.5em;
}
.logo-container .logo {
  font-size: inherit;
}
.logo-container .logo .logo-image {
  width: 4em;
}
.logo-container .headings {
  font-size: inherit;
}
.logo-container .headings .title {
  font-size: 1.7em;
  line-height: 1em;
  font-family: "Staatliches";
  color: var(--ion-color-secondary);
  letter-spacing: 5px;
  vertical-align: text-top;
  text-align: left;
}
.logo-container .headings .title .dine {
  color: var(--ion-color-tertiary);
}
.logo-container .headings .subtitle {
  color: var(--ion-color-dark);
  font-style: italic;
}
.logo-container .headings .subtitle .powered-by {
  color: #555;
  text-transform: lowercase;
}
/*# sourceMappingURL=signature.component.css.map */
